import { actionType } from './actions';

const initialState = {
    countries: [],
    states: [],
    fundTypes: [],
    fundFilingTypes: [],
    renewalCycleTypes: [],
    paymentTypes: [],
    permitNumberTypes: [],
    mailingMethodTypes: [],
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_COMMON_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_COMMON_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_COUNTRIES: {
            return {
                ...state,
                countries: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_STATES: {
            return {
                ...state,
                states: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_FUND_TYPES: {
            return {
                ...state,
                fundTypes: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_FUND_FILING_TYPES: {
            return {
                ...state,
                fundFilingTypes: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_RENEWAL_CYCLE_TYPES: {
            return {
                ...state,
                renewalCycleTypes: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PAYMENT_TYPES: {
            return {
                ...state,
                paymentTypes: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PERMIT_NUMBER_TYPES: {
            return {
                ...state,
                permitNumberTypes: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_MAILING_METHOD_TYPES: {
            return {
                ...state,
                mailingMethodTypes: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/commonData/reducers.js